<template>
    <div class="simple-layout-container">
        <label class="session-message">
          <v-icon name="times" class="icon-red" />&nbsp;&nbsp;{{ $t("message.sessionTimeoutMessage") }}
        </label>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'SessionTimeout',
        mounted () {
            // We are going to call the Logout function so we can go ahead and wipe out the session information
            // No need to redirect to another URL from here as this will get rendered as part of an iframe and we want the end user to stay at this page
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Login/Logout?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data; 
                this.clearSessionBeforeSetup();
                this.$store.dispatch('resetApp');
            }, error => {
                console.log(error);
            });
        },
        methods: {
            clearSessionBeforeSetup() {
                axios({
                    method: "GET",
                    url: this.$httpAxiosBaseUrl() + "Login/ClearSessionForLoginPage?date=" + new Date().getTime()
                }).then(result => {
                    var response = result.data;                
                }, error => {
                    console.log(error);
                });
            }
        }     
    }
</script>
